var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"content"},[(_vm.showLoading)?_c('loading-animation',{staticClass:"row border border-top-0"}):_vm._e()],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }